import { render, staticRenderFns } from "./MitHomePage.vue?vue&type=template&id=551913d2&scoped=true"
import script from "./MitHomePage.vue?vue&type=script&lang=js"
export * from "./MitHomePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551913d2",
  null
  
)

export default component.exports